<template>
  <div class="share-money">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="back" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <h1>{{ $t('share_earn') }}</h1>
      <div class="header-right"></div>
    </div>
    
    <!-- 页面内容 -->
    <div class="content">
      <!-- 推广链接 -->
      <div class="promotion-section">
        <div class="invite-container">
          <div class="invite-header-row">
            <div class="invite-header">
              <h3>{{ $t('invite_link') }}</h3>
            </div>
            
            <div class="invite-stats">
              <div class="invite-stat-item">
                <span class="stat-label">{{ $t('direct_invites') }}</span>
                <span class="stat-value">{{ stats.directAgents || 0 }} {{ $t('people') }}</span>
              </div>
            </div>
          </div>
          
          <div class="invite-link-box">
            <input type="text" :value="normalLink" readonly class="invite-link-input">
            <button class="copy-btn" @click="copyLink('normal')">
              {{ $t('copy') }}
            </button>
          </div>
          
          <div class="invite-qr-code">
            <img :src="qrCodeUrl" alt="QR Code" class="qr-code-image" ref="qrCodeImage">
            <button class="save-qr-btn" @click="saveQRCode">{{ $t('save_to_album') }}</button>
          </div>
        </div>
      </div>
      
      <!-- 阶梯领取奖励 -->
      <div class="tier-rewards-section">
        <div class="section-title">
          <span class="section-icon">{{ $t('tier_rewards') }}</span>
          <span class="section-note">{{ $t('tier_reward_note') }}</span>
        </div>
        
        <div class="tier-rewards-grid">
          <div v-for="reward in tierRewards" :key="reward.tier" class="tier-reward-card" 
               :class="{ 
                 'can-claim': stats.totalAgents >= reward.inviteCount && !reward.claimed,
                 'claimed': reward.claimed
               }">
            <div class="reward-icon">
              <img v-if="reward.claimed" :src="getRewardIcon('claimed')" alt="Claimed" class="icon-image">
              <img v-else-if="stats.totalAgents >= reward.inviteCount" :src="getRewardIcon('can-claim')" alt="Can Claim" class="icon-image">
              <img v-else :src="getRewardIcon('locked')" alt="Locked" class="icon-image">
            </div>
            <div class="invite-count">{{ $t('invite_people', { count: reward.inviteCount }) }}</div>
        
            <div class="reward-amount">
              <span class="currency">¥</span>
              <span class="amount">{{ reward.reward }}</span>
            </div>
            <button class="claim-btn" 
                    @click="claimTierReward(reward.tier)"
                    :disabled="reward.claimed || stats.totalAgents < reward.inviteCount">
              {{ reward.claimed ? $t('claimed') : (stats.totalAgents >= reward.inviteCount ? $t('claim') : $t('not_met')) }}
            </button>
          </div>
        </div>
      </div>
      
      <!-- 邀请规则 -->
      <div class="promotion-section">
        <div class="invite-container">
          <div class="invite-header">
            <h3>{{ $t('invite_rules') }}</h3>
          </div>
          <div class="invite-stats">
            <p class="rule-text">{{ $t('rule1') }}</p>
            <p class="rule-text">{{ $t('rule2') }}</p>
            <p class="rule-text warning">{{ $t('warning') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shareMoney',
  data() {
    return {
      normalLink: 'https://aa451...',
      wechatLink: 'http://7lb-7dwo...',
      rebateData: {
        daily: 0,
        weekly: 0,
        monthly: 0
      },
      currentSlide: 0,
      slideInterval: null,
      tierRewards: [],
      currentInviteCount: 0,
      directInvites: 0,
      validInvites: 0,
      inviteCode: '',
      qrCodeUrl: '',
      stats: {
        totalMembers: 0,
        totalAgents: 0,
        directMembers: 0,
        directAgents: 0
      }
    };
  },
  created() {
    this.getShareInfo();
    this.getTeamStats();
  },
  mounted() {
    this.startCarousel();
  },
  beforeDestroy() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  },
  methods: {
    getRewardIcon(type) {
      const icons = {
        'locked': '/static/style/baulock.png',
        'can-claim': '/static/style/bauliberado.png',
        'claimed': '/static/style/bauaberto.png'
      };
      return icons[type] || '';
    },
getShareInfo() {
  var that = this;
  
  // 获取推广链接
  this.$apiFun.post('/api/getAgentInfo').then(function(res) {
    if (res.code === 200 && res.data) {
      var userId = localStorage.getItem('userId') || '';
      that.normalLink = res.data.wap_url || (window.location.origin + '/#/register?pid=' + userId);
      that.qrCodeUrl = that.generateQrCodeUrl();
    }
  }).catch(function(err) {
    console.error('获取分享信息错误:', err);
    var userId = localStorage.getItem('userId') || '1';
    that.normalLink = window.location.origin + '/#/register?pid=' + userId;
    that.qrCodeUrl = that.generateQrCodeUrl();
  });
  
  // 从后端获取阶梯奖励数据
  that.$apiFun.post('/api/tier-rewards', {}).then(function(res) {
    console.log('阶梯奖励返回:', res);
    if (res.code === 200 && res.data && res.data.rewards) {
      that.tierRewards = res.data.rewards;
      that.currentInviteCount = res.data.currentInviteCount || 0;
      that.directInvites = res.data.directInvites || 0;
      that.validInvites = res.data.validInvites || 0;
    }
  }).catch(function(err) {
    console.error('获取阶梯奖励错误:', err);
  });
},
    generateQrCodeUrl() {
      var encodedUrl = encodeURIComponent(this.normalLink);
      return 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + encodedUrl;
    },
    saveQRCode() {
      var img = this.$refs.qrCodeImage;
      if (!img) {
        alert(this.$t('qr_code_not_found'));
        return;
      }
      
      var canvas = document.createElement('canvas');
      canvas.width = 300;
      canvas.height = 300;
      var ctx = canvas.getContext('2d');
      
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      var imgWidth = 280;
      var imgHeight = 280;
      var imgX = (canvas.width - imgWidth) / 2;
      var imgY = (canvas.height - imgHeight) / 2;
      
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function() {
        ctx.drawImage(image, imgX, imgY, imgWidth, imgHeight);
        
        canvas.toBlob(function(blob) {
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = this.$t('qr_code_filename');
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          alert(this.$t('qr_code_saved'));
        }.bind(this));
      }.bind(this);
      image.onerror = function() {
        alert(this.$t('qr_code_save_failed'));
      }.bind(this);
      image.src = img.src;
    },
    copyInviteCode() {
      var input = document.createElement('input');
      input.value = this.inviteCode || 'PEMW88DUN';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert(this.$t('invite_code_copied'));
    },
    getTeamStats() {
      var that = this;
      
      that.$apiFun.get('/api/team/performance').then(function(res) {
        console.log('获取团队统计:', res);
        if (res.code === 200 && res.data) {
          that.stats = {
            totalMembers: res.data.totalMembers || 0,
            totalAgents: res.data.totalAgents || 0,
            directMembers: res.data.directMembers || 0,
            directAgents: res.data.directAgents || 0
          };
          that.directInvites = res.data.directAgents || 0;
          that.currentInviteCount = res.data.totalAgents || 0;
          that.validInvites = res.data.totalAgents || 0;
        }
      }).catch(function(err) {
        console.error('获取团队统计错误:', err);
      });
    },
    shareToSocial(platform) {
      var url = this.normalLink;
      var text = this.$t('share_text');
      
      switch (platform) {
        case 'facebook':
          window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank');
          break;
        case 'twitter':
          window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(text), '_blank');
          break;
        case 'whatsapp':
          window.open('https://wa.me/?text=' + encodeURIComponent(text + ' ' + url), '_blank');
          break;
        case 'telegram':
          window.open('https://t.me/share/url?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(text), '_blank');
          break;
        case 'instagram':
          alert(this.$t('share_manually'));
          break;
        default:
          break;
      }
    },
    copyLink(type) {
      var link = type === 'normal' ? this.normalLink : this.wechatLink;
      var input = document.createElement('input');
      input.value = link;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert(this.$t('link_copied'));
    },
    shareImage(type) {
      alert(this.$t('share_image_triggered'));
    },
    startCarousel() {
      var that = this;
      this.slideInterval = setInterval(function() {
        that.nextSlide();
      }, 3000);
    },
    nextSlide() {
      var slides = document.querySelectorAll('.banner-slide');
      var dots = document.querySelectorAll('.banner-dot');
      
      if (slides.length === 0 || dots.length === 0) return;
      
      slides[this.currentSlide].style.display = 'none';
      dots[this.currentSlide].classList.remove('dot-active');
      
      this.currentSlide = (this.currentSlide + 1) % slides.length;
      
      slides[this.currentSlide].style.display = 'block';
      dots[this.currentSlide].classList.add('dot-active');
    },
    claimTierReward(tier) {
      console.log('开始领取奖励，tier:', tier);
      var reward = null;
      for (var i = 0; i < this.tierRewards.length; i++) {
        if (this.tierRewards[i].tier === tier) {
          reward = this.tierRewards[i];
          break;
        }
      }
      console.log('找到的奖励:', reward);
      if (!reward) {
        alert(this.$t('reward_not_exist'));
        return;
      }
      
      if (reward.claimed) {
        alert(this.$t('reward_already_claimed'));
        return;
      }
      
      if (this.stats.totalAgents < reward.inviteCount) {
        alert(this.$t('reward_condition_not_met', { count: reward.inviteCount - this.stats.totalAgents }));
        return;
      }
      
      console.log('调用后端API领取奖励，tier:', tier);
      var that = this;
      this.$apiFun.post('/api/claim-tier-reward', { tier: tier }).then(function(res) {
        console.log('API返回结果:', res);
        if (res.code === 200) {
          reward.claimed = true;
          alert(that.$t('reward_claimed_success', { tier: tier, amount: reward.reward }));
        } else {
          alert(res.msg || that.$t('reward_claim_failed'));
        }
      }).catch(function(err) {
        console.error('领取奖励错误:', err);
        alert(that.$t('reward_claim_failed'));
      });
    }
  }
};
</script>

<style scoped>
.share-money {
  min-height: 100vh;
  background: linear-gradient(135deg, #fff, #fff);
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-image: url(/static/css/top_area_bg-w1ddLS2U.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(58, 123, 213, 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.header > * {
  z-index: 2;
}

.back {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back i {
  font-size: 20px;
  color: #fff;
  transition: all 0.3s ease;
}

.back:hover i {
  transform: translateX(-2px);
}

.header h1 {
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 1px;
}

.header-right {
  width: 40px;
}

.content {
  padding-top: 60px;
  padding-bottom: 30px;
  max-width: 600px;
  margin: 0 auto;
}

.promotion-section {
  background: #fff;
  margin: 20px 15px;
  border-radius: 16px;
  padding: 25px;
  animation: fadeIn 0.8s ease forwards;
  animation-delay: 0.2s;
  transition: all 0.3s ease;
}

.invite-container {
  border-radius: 16px;
  padding: 25px;
  color: #000000;
  transition: all 0.3s ease;
}

.invite-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.invite-header {
  margin-bottom: 0;
}

.invite-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}

.invite-link-box {
  display: flex;
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.invite-link-box .invite-link-input {
  flex: 1;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #050505;
  font-size: 14px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  backdrop-filter: blur(10px);
}

.invite-link-box .invite-link-input:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.4);
}

.invite-link-box .copy-btn {
  padding: 0 20px;
  background: linear-gradient(135deg, #3a7bd5, #3d72fa);
  border: none;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(58, 123, 213, 0.3);
}

.invite-link-box .copy-btn:hover {
  background: linear-gradient(135deg, #00d2ff, #3a7bd5);
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(58, 123, 213, 0.4);
}

.invite-stats .invite-stat-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.invite-stats .stat-label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 500;
}

.invite-stats .stat-value {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000000;
}

.invite-stats .rule-text {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
  color: rgba(36, 36, 36, 0.9);
  text-align: left;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.invite-stats .rule-text.warning {
  color: #ff6b6b;
  font-weight: 500;
  margin-top: 15px;
  padding: 10px;
  background: rgba(255, 107, 107, 0.2);
  border-radius: 8px;
}

.invite-qr-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.invite-qr-code .qr-code-image {
  width: 150px;
  height: 150px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  background: #fff;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  margin-bottom: 15px;
}

.invite-qr-code .qr-code-image:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.invite-qr-code .save-qr-btn {
  padding: 12px 24px;
  background: linear-gradient(135deg, #3d72fa, #3d72fa);
  border: none;
  border-radius: 25px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(43, 54, 154, 0.3);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.invite-qr-code .save-qr-btn:hover {
  background: linear-gradient(135deg, #1e297d, #2b369a);
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 6px 16px rgba(43, 54, 154, 0.4);
}

.invite-qr-code .save-qr-btn:active {
  transform: translateY(-1px) scale(0.98);
  box-shadow: 0 2px 8px rgba(43, 54, 154, 0.3);
}

.tier-rewards-section {
  margin: 20px 15px;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
  position: relative;
}

.section-title:after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 60px;
  height: 2px;
  border-radius: 2px;
}

.section-icon {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-right: 10px;
  position: relative;
}

.section-note {
  font-size: 12px;
  color: #999;
  margin-left: auto;
}

.tier-rewards-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}

.tier-reward-card {
  background: linear-gradient(135deg, #f8f9ff, #e3f2fd);
  border: 1px solid rgba(58, 123, 213, 0.2);
  border-radius: 16px;
  padding: 15px 12px;
  text-align: center;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.tier-reward-card:before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.tier-reward-card:hover {
  transform: translateY(-5px) scale(1.02);
  border-color: rgba(58, 123, 213, 0.4);
}

.tier-reward-card:hover:before {
  left: 100%;
}

.tier-reward-card.can-claim {
  background: linear-gradient(135deg, #fff3e0, #ffe0b2);
  border: 2px solid #ff9f43;
  animation: pulse 2s infinite;
}

.tier-reward-card.claimed {
  background: linear-gradient(135deg, #e8f5e8, #c8e6c9);
  border: 2px solid #4caf50;
  opacity: 0.9;
}

.reward-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 12px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 0.4s ease;
}

.tier-reward-card:hover .icon-image {
  transform: scale(1.15) rotate(-5deg);
}

.tier-reward-card.can-claim .icon-image {
  animation: bounce 1s infinite;
}

.invite-count {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
  font-weight: 500;
}

.reward-amount {
  margin-bottom: 15px;
  position: relative;
  z-index: 1;
}

.reward-amount .currency {
  font-size: 16px;
  color: #ff6b6b;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.reward-amount .amount {
  font-size: 28px;
  font-weight: bold;
  color: #ff6b6b;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.tier-reward-card:hover .reward-amount .amount {
  transform: scale(1.1);
}

.claim-btn {
  width: 100%;
  padding: 10px 0;
  border: none;
  border-radius: 25px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s ease;
  background: linear-gradient(135deg, #e0e0e0, #bdbdbd);
  color: #666;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.claim-btn:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), transparent);
  z-index: -1;
}

.claim-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15);
}

.claim-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.tier-reward-card.can-claim .claim-btn {
  background: linear-gradient(135deg, #ff9f43, #ee5a24);
  color: #fff;
}

.tier-reward-card.can-claim .claim-btn:hover:not(:disabled) {
  transform: translateY(-3px) scale(1.05);
}

.tier-reward-card.claimed .claim-btn {
  background: linear-gradient(135deg, #4caf50, #45a049);
  color: #fff;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 159, 67, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(255, 159, 67, 0);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .tier-rewards-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }
  
  .tier-reward-card {
    padding: 12px 8px;
  }
  
  .invite-count {
    font-size: 11px;
  }
  
  .reward-amount .amount {
    font-size: 20px;
  }
  
  .claim-btn {
    padding: 7px 0;
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .tier-rewards-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
  
  .tier-reward-card {
    padding: 10px 6px;
  }
  
  .invite-count {
    font-size: 10px;
  }
  
  .reward-amount .currency {
    font-size: 12px;
  }
  
  .reward-amount .amount {
    font-size: 18px;
  }
  
  .claim-btn {
    padding: 6px 0;
    font-size: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shareMoney.vue